"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zipCode = exports.samePasswords = exports.sameAs = exports.requiredYesNo = exports.requiredWork = exports.requiredValue = exports.requiredRelationship = exports.requiredRange = exports.requiredProvider = exports.requiredOwner = exports.requiredOn = exports.requiredMoney = exports.requiredMaritalStatus = exports.requiredLastName = exports.requiredFirstName = exports.requiredEmploymentStatus = exports.requiredDescription = exports.requiredData = exports.requiredCustom = exports.requiredCompanyName = exports.requiredBooleanAnswer = exports.requiredAtLeastOne = exports.requiredAnswer = exports.required = exports.rangeValue = exports.rangeLength = exports.positiveNumber = exports.phoneValidation = exports.phoneIfNotEmptyLength = exports.numberFormat = exports.minValue10 = exports.minValue = exports.minSize = exports.minLengthNumYear = exports.minLengthNum = exports.minLength = exports.maxValue20k = exports.maxValue100 = exports.maxValue = exports.maxLengthNumYear = exports.maxLengthNumRooms = exports.maxLengthNumLivSpace = exports.maxLengthNum = exports.maxLength = exports.markRequired = exports.mandatory = exports.isYear = exports.isValidIban = exports.isValidEmail = exports.isUrl = exports.isText = exports.isPromocode = exports.isPostcode = exports.isPositiveNumberCustom = exports.isPhoneRequired = exports.isPhone = exports.isPasswordCustom = exports.isPassword = exports.isNumber = exports.isNicknameCustom = exports.isNickname = exports.isLongEnough = exports.isInteger = exports.isImage = exports.isEmailCustom = exports.isEmail = exports.isCustomUrl = exports.isCustomUppercaseAndNumber = exports.isCustomTextAndNumber = exports.isCustomText = exports.containsAllRequiredCharacters = exports.checkNin = exports.booleanRequired = void 0;
var _isString = _interopRequireDefault(require("lodash/isString"));
var _get = _interopRequireDefault(require("lodash/get"));
var _helper = require("./helper");
var _regExp = _interopRequireDefault(require("./regExp.constant"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const mandatory = param => {
  throw new Error(`Parameter(s) {${param}} is required.`);
};
exports.mandatory = mandatory;
const isEmail = value => (0, _helper.isEmpty)(value) || _regExp.default.email.test(value) ? true : 'Invalid Email';
exports.isEmail = isEmail;
const isValidIban = value => (0, _helper.isEmpty)(value) || _regExp.default.iban.test(value) ? true : 'Invalid IBAN';
exports.isValidIban = isValidIban;
const isValidEmail = async (value, baseURL) => {
  const error = (0, _helper.isEmpty)(value) || _regExp.default.email.test(value) ? true : 'Invalid Email';
  let data = [(0, _helper.isEmpty)(value) || _regExp.default.email.test(value) ? 'valid' : 'Invalid Email'];
  const savedEmail = localStorage.getItem('checkedEmail');
  if (savedEmail === value) {
    return {
      message: 'checked',
      allData: {
        email: value
      }
    };
  }
  if (error === true && !(0, _helper.isEmpty)(value)) {
    data = [fetch(`${baseURL}/user/verify/${value}`).then(response => response.json()).catch(response => response.json())];
  }
  const getResponseMail = await Promise.all(data);
  const result = getResponseMail.map(item => {
    let message = item;
    if ((0, _get.default)(item, 'result', null)) {
      if (item.result === 'invalid') message = 'Please use a valid e-mail address';else message = true;
    }
    if ((0, _get.default)(item, 'statusCode', null) === 500) {
      message = true;
    }
    localStorage.setItem('checkedEmail', value);
    return {
      message,
      allData: item
    };
  });
  if ((0, _get.default)(result[0], 'statusCode', null) === 500) {
    return true;
  }
  return result[0];
};
exports.isValidEmail = isValidEmail;
const isPostcode = value => {
  const replacedValue = value.replace(/^\s+|\s+$/g, '').replace(/ /g, '');
  const error = (0, _helper.isEmpty)(replacedValue) || _regExp.default.postcode.test(replacedValue) ? true : 'This is not a valid postcode';
  return error;
};
exports.isPostcode = isPostcode;
const isEmailCustom = (errorMessage = 'Invalid Email') => value => {
  const error = (0, _helper.isEmpty)(value) || _regExp.default.email.test(value) ? true : errorMessage;
  return error;
};
exports.isEmailCustom = isEmailCustom;
const isPasswordCustom = (errorMessage = 'Wrong Password') => value => {
  const error = (0, _helper.isEmpty)(value) || _regExp.default.password.test(value) ? true : errorMessage;
  return error;
};
exports.isPasswordCustom = isPasswordCustom;
const isPassword = value => {
  const error = (0, _helper.isEmpty)(value) || _regExp.default.password.test(value) ? null : 'Invalid Password';
  return error;
};
exports.isPassword = isPassword;
const isLongEnough = value => value.length > 7 ? null : 'Too short: you need 8+ characters';
exports.isLongEnough = isLongEnough;
const containsAllRequiredCharacters = value => {
  // eslint-disable-next-line max-len
  const error = !(0, _helper.isEmpty)(value) && _regExp.default.hasNumber.test(value) && _regExp.default.hasUppercaseLetter.test(value) && _regExp.default.hasLowercaseLetter.test(value) && _regExp.default.hasSpecialCharacter.test(value) ? true : 'Too weak: 1 uppercase letter, 1 lower case letter, 1 number and 1 special character';
  return error;
};
exports.containsAllRequiredCharacters = containsAllRequiredCharacters;
const isPromocode = value => {
  const error = (0, _helper.isEmpty)(value) || _regExp.default.allSymbols.test(value) ? true : 'Invalid value';
  return error;
};
exports.isPromocode = isPromocode;
const isText = value => {
  const error = (0, _helper.isEmpty)(value) || _regExp.default.text.test(value) ? true : 'Value must me a text';
  return error;
};
exports.isText = isText;
const isCustomText = (errorMessage = 'Not Valid URL') => value => {
  const error = (0, _helper.isEmpty)(value) || _regExp.default.text.test(value) ? true : errorMessage;
  return error;
};
exports.isCustomText = isCustomText;
const isCustomTextAndNumber = (errorMessage = 'Not Valid URL') => value => {
  const error = (0, _helper.isEmpty)(value) || _regExp.default.characterAndNumber.test(value) ? null : errorMessage;
  return error;
};
exports.isCustomTextAndNumber = isCustomTextAndNumber;
const isCustomUppercaseAndNumber = (errorMessage = 'Not Valid URL') => value => {
  const error = (0, _helper.isEmpty)(value) || _regExp.default.upperCaseAndNumber.test(value) ? true : errorMessage;
  return error;
};
exports.isCustomUppercaseAndNumber = isCustomUppercaseAndNumber;
const isNickname = value => {
  const error = (0, _helper.isEmpty)(value) || _regExp.default.personName.test(value) ? true : 'Invalid nickname';
  return error;
};
exports.isNickname = isNickname;
const isNicknameCustom = (errorMessage = 'Invalid username') => value => {
  const error = (0, _helper.isEmpty)(value) || _regExp.default.personName.test(value) ? true : errorMessage;
  return error;
};
exports.isNicknameCustom = isNicknameCustom;
const isUrl = value => {
  const error = (0, _helper.isEmpty)(value) || _regExp.default.url.test(value) ? true : 'Invalid url';
  return error;
};
exports.isUrl = isUrl;
const isCustomUrl = (errorMessage = 'Not Valid URL') => value => {
  const error = (0, _helper.isEmpty)(value) || _regExp.default.url.test(value) ? true : errorMessage;
  return error;
};
exports.isCustomUrl = isCustomUrl;
const isPhone = value => {
  const error = (0, _helper.isEmpty)(value) || _regExp.default.mobilePhone.test(value) ? true : 'Insert a valid phone number';
  return error;
};
exports.isPhone = isPhone;
const isPhoneRequired = exports.isPhoneRequired = isPhone('Enter valid phone number');
const isImage = value => {
  const error = (0, _helper.isEmpty)(value) || _regExp.default.image.test(value) ? true : 'The type of the file is invalid. You can upload image file only.';
  return error;
};
exports.isImage = isImage;
const required = value => {
  const error = !(0, _helper.isEmpty)(value) || value === true || value === false ? true : '* Required';
  return error;
};
exports.required = required;
const booleanRequired = value => {
  const error = (0, _helper.isBoolean)(value) ? true : 'Select an option';
  return error;
};
exports.booleanRequired = booleanRequired;
const requiredBooleanAnswer = value => {
  const error = (0, _helper.isBoolean)(value) ? true : 'Please answer this question';
  return error;
};
exports.requiredBooleanAnswer = requiredBooleanAnswer;
const requiredCustom = (errorMessage = '* Required') => value => {
  const error = !(0, _helper.isEmpty)(value) ? true : errorMessage;
  return error;
};
exports.requiredCustom = requiredCustom;
const zipCode = (value, props) => {
  const country = (0, _get.default)(props, 'inputFormat.country', '').toLowerCase();
  let zipRegex;
  if (country === 'pt') zipRegex = new RegExp(/^\d{4}(?:[-\s]\d{3})?$/gm);
  if (country === 'ch') zipRegex = new RegExp(/^\d{4}?$/gm);
  if (country === 'it') zipRegex = new RegExp(/^\d{5}?$/gm);
  if (country === 'de') zipRegex = new RegExp(/^\d{5}?$/gm);
  if (zipRegex) {
    if (zipRegex.test(value)) return true;
    return 'Please insert a valid zip code';
  }
  return true;
};
exports.zipCode = zipCode;
const requiredMoney = exports.requiredMoney = requiredCustom('This field is required (enter zero if none)');
const requiredValue = exports.requiredValue = requiredCustom('A value is required');
const requiredWork = exports.requiredWork = requiredCustom('Please choose work situation');
const requiredCompanyName = exports.requiredCompanyName = requiredCustom('Company name is required');
const requiredEmploymentStatus = exports.requiredEmploymentStatus = requiredCustom('Please choose employment status');
const requiredData = exports.requiredData = requiredCustom('Date is required');
const requiredMaritalStatus = exports.requiredMaritalStatus = requiredCustom('Marital status is required');
const requiredYesNo = exports.requiredYesNo = requiredCustom('Please select an option');
const requiredAtLeastOne = exports.requiredAtLeastOne = requiredCustom('Please select at least one');
const requiredDescription = exports.requiredDescription = requiredCustom('Description is required');
const requiredRelationship = exports.requiredRelationship = requiredCustom('Please choose relationship');
const requiredFirstName = exports.requiredFirstName = requiredCustom('First name is required');
const requiredLastName = exports.requiredLastName = requiredCustom('Last name is required');
const requiredRange = exports.requiredRange = requiredCustom('Please choose range');
const requiredAnswer = exports.requiredAnswer = requiredCustom('Please answer this question');
const requiredOwner = exports.requiredOwner = requiredCustom('Please choose owner');
const requiredProvider = exports.requiredProvider = requiredCustom('Provider name is required');
const sameAs = key => (value, values) => {
  // @ts-ignore
  const error = value === values[key] ? true : 'Passwords are not the same';
  return error;
};
// eslint-disable-next-line no-confusing-arrow
exports.sameAs = sameAs;
const samePasswords = (value, allValues) => value === allValues.password ? null : 'Passwords don\'t match';
// eslint-disable-next-line react/destructuring-assignment
exports.samePasswords = samePasswords;
const requiredOn = (key, errorMessage = '* Required') => (value, values) => values[key] && (0, _helper.isEmpty)(value) ? errorMessage : null;
exports.requiredOn = requiredOn;
const minLength = min => value => {
  // eslint-disable-next-line react/destructuring-assignment
  const formattedValue = value ? value.toString() : null;
  if (!formattedValue) return null;
  return (0, _helper.isEmpty)(value) || formattedValue.trim().length >= min ? true : `Must be at least ${min} characters`;
};
exports.minLength = minLength;
const maxLength = max => (errorMessage = 'Not valid') => value => {
  // eslint-disable-next-line react/destructuring-assignment
  const formattedValue = value ? value.toString() : null;
  if (!formattedValue) return null;
  const error = (0, _helper.isEmpty)(value) || formattedValue.trim().length <= max ? null : errorMessage;
  return error;
};
exports.maxLength = maxLength;
const minSize = value => {
  const formattedValue = value ? value[0] : {
    size: 0
  };
  return value && formattedValue.size <= 0 ? 'File can not be empty' : null;
};
exports.minSize = minSize;
const isYear = value => {
  const minimumYear = 1000;
  const currentYear = new Date().getFullYear();
  const isNumber = Number.isInteger(+value);
  const isInValidYearDiapason = minimumYear <= +value && +value <= currentYear;
  if (!(0, _helper.isEmpty)(value) && !isNumber) return 'Is not a number';
  if (!(0, _helper.isEmpty)(value) && !isInValidYearDiapason) return 'Is not valid year';
  return null;
};
exports.isYear = isYear;
const isInteger = value => {
  const formattedValue = value && value.replace && value.replace(/\s+/g, '') || value;
  const error = !(0, _helper.isEmpty)(value) && !Number.isInteger(Number(formattedValue)) ? 'Must be an integer' : null;
  return error;
};
exports.isInteger = isInteger;
const minValue = min => value => {
  const error = ((0, _helper.isEmpty)(value) ? false : +value < +min) ? `Value can't be smaller than ${min}` : null;
  return error;
};
exports.minValue = minValue;
const minValue10 = exports.minValue10 = minValue(10);
const maxValue = max => value => ((0, _helper.isEmpty)(value) ? false : +value > +max) ? `Value can't be greater than ${max}` : null;
exports.maxValue = maxValue;
const maxValue100 = exports.maxValue100 = maxValue(100);
const maxValue20k = exports.maxValue20k = maxValue(20000);
const isNumber = value => {
  // eslint-disable-next-line no-nested-ternary
  const error = ((0, _helper.isEmpty)(value) ? false : Number.parseFloat(String(value)) !== +value) ? 'Value must be an integer' : value > 999999999999999 ? 'Value must be lower' : null;
  return error;
};
exports.isNumber = isNumber;
const positiveNumber = value => {
  const error = ((0, _helper.isEmpty)(value) ? false : +value <= 0) ? 'Value must be greater than 0' : null;
  return error;
};
exports.positiveNumber = positiveNumber;
const isPositiveNumberCustom = (errorMessage = 'Not Positive Number') => value => {
  const error = ((0, _helper.isEmpty)(value) ? false : !_regExp.default.positiveNumber.test(value)) ? errorMessage : null;
  return error;
};
exports.isPositiveNumberCustom = isPositiveNumberCustom;
const numberFormat = value => {
  const error = ((0, _helper.isEmpty)(value) ? false : !_regExp.default.twoDecimal.test(value)) ? 'Format must me XX.XX' : null;
  return error;
};
exports.numberFormat = numberFormat;
const rangeValue = (min, max) => value => {
  const error = ((0, _helper.isEmpty)(value) ? false : +value > +max || +value < +min) ? `Value must be from ${min} to ${max}` : null;
  return error;
};
exports.rangeValue = rangeValue;
const rangeLength = (min, max) => value => {
  let error;
  if ((0, _helper.isEmpty)(value) ? false : value.length < min) {
    error = `Must be at least ${min} characters`;
  } else if ((0, _helper.isEmpty)(value) ? false : value.length > max) {
    error = `Must be less than ${max} characters`;
  }
  return error;
};
exports.rangeLength = rangeLength;
const checkNin = value => {
  const error = (0, _helper.isEmpty)(value) || _regExp.default.nin.test(value) && !_regExp.default.nin_exp.test(value) ? null : 'This is not a valid NIN';
  return error;
};
exports.checkNin = checkNin;
const maxLengthNum = (val, name) => value => {
  if (value && +value > +val) {
    return name === 'year' ? `Year can't be after ${val}` : `The ${name} have to be less then ${val}`;
  }
  return null;
};
exports.maxLengthNum = maxLengthNum;
const minLengthNum = (val, name) => value => {
  if (value && +value < +val) {
    return name === 'year' ? `Too old! year can't be before ${val}` : `The ${name} have to be more then ${val}`;
  }
  return null;
};
exports.minLengthNum = minLengthNum;
const minLengthNumYear = exports.minLengthNumYear = minLengthNum(1500, 'year');
const maxLengthNumRooms = exports.maxLengthNumRooms = maxLengthNum(30, 'rooms');
const maxLengthNumLivSpace = exports.maxLengthNumLivSpace = maxLengthNum(9999, 'living space');
const maxLengthNumYear = exports.maxLengthNumYear = maxLengthNum(2031, 'year');
const markRequired = value => {
  const error = !(0, _helper.isEmptyWithBool)(value) ? true : 'Mark Required';
  return error;
};
exports.markRequired = markRequired;
const phoneValidation = value => {
  if ((0, _isString.default)(value) && value || (0, _get.default)(value, 'number', null)) {
    return (0, _helper.telephoneFormat)(value, false, false, false, false, {
      validate: true
    });
  }
  return null;
};
exports.phoneValidation = phoneValidation;
const phoneIfNotEmptyLength = value => {
  const prefix = (0, _get.default)(value, 'prefix', '');
  const number = (0, _get.default)(value, 'number', '');
  if (prefix === '+351') {
    if (number && number.toString().length !== 9) {
      return 'Please insert a valid number';
    }
    return true;
  }
  if (prefix === '+41') {
    if (number && number.toString().length < 9) {
      return 'Please insert a valid number';
    }
    return true;
  }
  return null;
};
exports.phoneIfNotEmptyLength = phoneIfNotEmptyLength;